(() => {
  const groupSelector = [
    '[data-zoda-toggle-group]',
    '[data-zoda-fabric-accordion]',
    '[data-zoda-ikigai-tech-accordion]',
    '[data-zoda-home-technology-accordion]',
    '[data-zoda-home-collection-accordion]',
    '[data-zoda-feature-accordion]',
    '[data-zoda-collection-accordion]',
    '.zoda-pdp__accordions',
    '.zoda-fabrics-craft__accordion',
    '.zoda-fabrics-feature__accordion'
  ].join(',');

  const itemSelector = [
    'details',
    '[data-zoda-pdp-accordion]',
    '[data-zoda-fabric-accordion-item]',
    '[data-zoda-feature-item]',
    '[data-zoda-collection-panel]',
    '.zoda-fabrics-craft__item',
    '.zoda-fabrics-feature__accordion-item'
  ].join(',');

  const getGroup = (item) => item?.closest(groupSelector);
  const getItems = (group) => Array.from(group?.querySelectorAll(`:scope > ${itemSelector}`) || []);
  const getTrigger = (item) =>
    item?.querySelector('[aria-expanded], summary, button, [role="button"]');

  const setItemOpen = (item, open) => {
    if (!item) return;
    if (item.tagName === 'DETAILS') item.open = open;
    item.classList.toggle('is-open', open);

    const trigger = getTrigger(item);
    if (trigger?.hasAttribute('aria-expanded')) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    item.querySelectorAll(':scope > [hidden], :scope > .zoda-pdp-acc__content').forEach((panel) => {
      const controlledByTrigger = panel.classList.contains('zoda-pdp-acc__content');
      if (controlledByTrigger || panel.hidden !== undefined) panel.hidden = !open;
    });
  };

  const isItemOpen = (item) => {
    if (!item) return false;
    if (item.tagName === 'DETAILS') return item.open;
    const trigger = getTrigger(item);
    return item.classList.contains('is-open') || trigger?.getAttribute('aria-expanded') === 'true';
  };

  const closeSiblings = (activeItem) => {
    const group = getGroup(activeItem);
    if (!group || !isItemOpen(activeItem)) return;
    getItems(group).forEach((item) => {
      if (item !== activeItem) setItemOpen(item, false);
    });
  };

  document.addEventListener('toggle', (event) => {
    const item = event.target?.closest?.(itemSelector);
    if (!item || item !== event.target || !isItemOpen(item)) return;
    closeSiblings(item);
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const trigger = target.closest('[aria-expanded], summary, button, [role="button"]');
    const item = trigger?.closest(itemSelector);
    if (!item || !getGroup(item)) return;

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => closeSiblings(item));
    });
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(groupSelector).forEach((group) => {
      const openItems = getItems(group).filter(isItemOpen);
      openItems.slice(1).forEach((item) => setItemOpen(item, false));
    });
  });

  const initFaqMain = (scope = document) => {
    scope.querySelectorAll('[data-zoda-faq-main]').forEach((root) => {
      if (root.dataset.zodaFaqReady === 'true') return;
      root.dataset.zodaFaqReady = 'true';

      const accordions = Array.from(root.querySelectorAll('[data-zoda-faq-accordion]'));
      const topics = Array.from(root.querySelectorAll('[data-zoda-faq-topic]'));

      const setTopicState = (activeTopic) => {
        topics.forEach((topic) => {
          const isActive = topic.dataset.zodaFaqTopicKey === activeTopic;
          topic.classList.toggle('is-active', isActive);
          if (isActive) {
            topic.setAttribute('aria-current', 'true');
          } else {
            topic.removeAttribute('aria-current');
          }
        });
      };

      const setActive = (accordion, index, shouldScroll = false) => {
        const items = Array.from(accordion?.querySelectorAll(':scope > [data-zoda-faq-item]') || []);
        if (!items.length) return;
        const activeIndex = Math.max(0, Math.min(index, items.length - 1));

        items.forEach((item, itemIndex) => {
          const open = itemIndex === activeIndex;
          const trigger = item.querySelector('[data-zoda-faq-trigger]');
          const panel = item.querySelector('.zoda-faq-main__panel');

          item.classList.toggle('is-open', open);
          if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.hidden = !open;
        });

        const activeGroup = accordion.closest('[data-zoda-faq-group]');
        const activeTopic = activeGroup?.dataset.zodaFaqTopicKey || items[activeIndex]?.dataset.zodaFaqTopicKey || '';
        setTopicState(activeTopic);

        if (shouldScroll) {
          (activeGroup || accordion).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      accordions.forEach((accordion) => {
        const items = Array.from(accordion.querySelectorAll(':scope > [data-zoda-faq-item]'));

        items.forEach((item, index) => {
          const trigger = item.querySelector('[data-zoda-faq-trigger]');
          if (trigger) trigger.addEventListener('click', () => setActive(accordion, index));
        });

        const openIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-open')));
        setActive(accordion, openIndex);
      });

      topics.forEach((topic) => {
        topic.addEventListener('click', (event) => {
          const targetId = topic.getAttribute('href')?.replace(/^#/, '');
          const group = targetId ? document.getElementById(targetId) : null;
          const accordion = group?.querySelector('[data-zoda-faq-accordion]');
          event.preventDefault();
          setActive(accordion, 0, true);
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initFaqMain());
  document.addEventListener('shopify:section:load', (event) => initFaqMain(event.target));
})();
